module.exports = __webpack_public_path__ + "static/media/neutral.1d8e571e.svg";